import React, { createContext, useContext, useEffect, useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { contentSections, contentSlug, contentName, contentPath, loadContent } from './contentUrl';
import { LanguageContext } from './LanguageContext';
const DetailId = createContext(null);
export function useDetailParams() {
  const params = useParams();
  const id = useContext(DetailId);
  return { ...params, id: id || params.id };
}
export default function ContentRoute({ section, children }) {
  const { id, slug } = useParams();
  const { selectedLanguage } = useContext(LanguageContext);
  const key = section + ':' + (id || slug);
  const [state, setState] = useState({});
  const config = contentSections[section];
  useEffect(() => {
    const controller = new AbortController();
    loadContent(section, controller.signal).then(items => {
      if (controller.signal.aborted) return;
      const matches = items.filter(item => id ? String(item.id) === id : contentSlug(item).toLowerCase() === slug.toLowerCase());
      setState({ key, item: matches.length === 1 ? matches[0] : null });
    }).catch(() => { if (!controller.signal.aborted) setState({ key, error: true }); });
    return () => controller.abort();
  }, [section, id, slug, key]);
  useEffect(() => {
    if (state.key === key && state.item) document.title = config.label + ' / ' + contentName(state.item) + ' | NX KMUTT';
  }, [state, key, config, selectedLanguage]);
  if (state.key !== key) return <p role="status" className="p-5">กำลังโหลด / Loading…</p>;
  if (state.error) return <p role="alert" className="p-5">โหลดข้อมูลไม่สำเร็จ / Unable to load content. <button onClick={() => window.location.reload()}>ลองใหม่ / Retry</button></p>;
  if (!state.item) return <main className="p-5"><h1>ไม่พบข้อมูล / Content not found</h1><Link to={'/' + config.path}>กลับ / Back</Link></main>;
  const canonical = contentPath(section, state.item);
  if (id || encodeURIComponent(slug) !== canonical.split('/').pop()) return <Navigate to={canonical} replace />;
  return <DetailId.Provider value={String(state.item.id)}>{children}</DetailId.Provider>;
}
